module.exports = __webpack_public_path__ + "static/media/economic.55aaab69.svg";